<div class="container">
  
<h2>Merge Behaviors</h2>
<small>Select the behavior you want to merge data from and the behavior you want to merge data to. <br>
  This will copy any recorded data from the source behavior to the destination behavior. And the source behavior will be deleted. This operation can´t be undone.<br>
  Only behaviors of the same type (Frequency, Duration, Interval) can be merged together.
</small>
  <div class="row">
    <div class="col-12">
      <div class="row mt-4" *ngFor="let behavior of behaviorsToMerge">
        <div class="col-md-5 mb-3 d-flex flex-column">
          <label for="sourceBehavior" class="form-label">Source Behavior (data will be copied from)</label>
          <p-dropdown id="sourceBehavior" 
                      [options]="sourceBehaviors" 
                      optionLabel="PatientBehaviorName" 
                      optionValue="ID"
                      placeholder="Select Source Behavior" 
                      [filter]="true" 
                      filterBy="PatientBehaviorName" 
                      [showClear]="true"
                      [(ngModel)]="behavior.BehaviorIDToMerge"
                      [disabled]="loading"
                      (onChange)="onSourceBehaviorChange(behavior)">
                      <ng-template pTemplate="selectedOption" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                          <div class="d-flex flex-column">
                            {{ selectedOption.PatientBehaviorName }}
                            <small style="font-size: 10px;">Type: {{ getBehaviorTypeLabel(selectedOption.BehaviorType) }}</small>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="item" let-option>
                        <div class="d-flex flex-column">
                          {{ option.PatientBehaviorName }}
                          <small style="font-size: 10px;">Type: {{ getBehaviorTypeLabel(option.BehaviorType) }}</small>
                        </div>
                      </ng-template>
          </p-dropdown>
        </div>
        <div class="col-md-5 mb-3 d-flex flex-column">
          <label for="destinationBehavior" class="form-label">Destination Behavior (data will be copied to)</label>
          <p-dropdown id="destinationBehavior" 
                      [options]="behavior.destinationBehaviors" 
                      optionLabel="PatientBehaviorName" 
                      optionValue="ID"
                      placeholder="Select Destination Behavior" 
                      [filter]="true" 
                      filterBy="PatientBehaviorName" 
                      [showClear]="true"
                      [(ngModel)]="behavior.BehaviorIDToMergeInto"
                      [disabled]="loading">
                      <ng-template pTemplate="selectedOption" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                          <div class="d-flex flex-column">
                            {{ selectedOption.PatientBehaviorName }}
                            <small style="font-size: 10px;">Type: {{ getBehaviorTypeLabel(selectedOption.BehaviorType) }}</small>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="item" let-option>
                        <div class="d-flex flex-column">
                          {{ option.PatientBehaviorName }}
                          <small style="font-size: 10px;">Type: {{ getBehaviorTypeLabel(option.BehaviorType) }}</small>
                        </div>
                      </ng-template>
          </p-dropdown>
        </div>
        <div class="col-12 col-md-2 d-flex align-items-center h-100 mb-3">
          
            <button class="btn btn-danger" 
                    type="button" 
                    (click)="behaviorsToMerge.splice(behaviorsToMerge.indexOf(behavior), 1)" 
                    [disabled]="loading || behaviorsToMerge.length <= 1">
              <i class="pi pi-trash"></i>
            </button>
          
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-12 col-sm-6">

          <button class="btn btn-primary" 
                  [disabled]="loading"
                  (click)="addBehavior()">
            Add Row
          </button>
        </div>
        <div class="col-12 col-sm-6 text-end">
          <button class="btn btn-primary" 
                  [disabled]="!behaviorsToMerge || !behaviorsToMerge.length || loading"
                  (click)="mergeBehaviors()">
            Merge Behaviors
          </button>
        </div>
      </div>

    </div>
  </div>

  <div class="row mb-5">

  </div>
</div>
<app-loading-indicator *ngIf="loading"></app-loading-indicator> 